export default "__VITE_ASSET__CZuaESqg__"